import { insightTabs } from '../../Insights'
import { ArrowSquareOutIcon, InfoIcon } from '@phosphor-icons/react'
import { BulletResults } from '../BulletResults/BulletResults'
import { VisualizeTree } from '../VisualizeTree/VisualizeTree'
import { ScoopGrid, ScoopTooltip, ScoopButton, ScoopText } from '../../../../ui'
import styles from './TimeAnalysisResult.module.scss'

export const TimeAnalysisResult = ({
    mlResults,
    selectedTab,
    setSelectedTab,
    setMlResults,
    mlConfig,
    setMlConfig,
}) => {
    const handleOpenInStudio = () => {
        if (setSelectedTab) {
            setSelectedTab(insightTabs[1].key)
            setMlResults(mlResults)
            mlConfig.periodOneConfig.timeRange = 'Custom'
            mlConfig.periodOneConfig.from = mlResults.groupOne.startDate
            mlConfig.periodOneConfig.to = mlResults.groupOne.endDate
            mlConfig.periodTwoConfig.timeRange = 'Custom'
            mlConfig.periodTwoConfig.from = mlResults.groupTwo.startDate
            mlConfig.periodTwoConfig.to = mlResults.groupTwo.endDate
            mlConfig.dateToUSe = mlResults.filterDate
            setMlConfig({ ...mlConfig })
        }
    }
    return (
        <>
            {mlResults && mlResults.error && (
                <div className={styles.errorContainer}>
                    <BulletResults mlResults={mlResults} />
                </div>
            )}
            {mlResults && mlResults.numInstances && (
                <div className={styles.resultsContainer}>
                    <ScoopGrid container gap={16} className={styles.gridContainer}>
                        <ScoopGrid item xs={11}>
                            <ScoopText variant="h2" className={styles.title}>
                                Time Period Analysis
                                <ScoopTooltip title="Time period analysis compares the data from two different time periods within your dataset. It attempts to find the key differences by analyzing what truly makes them unique and then summarizing the results. It attempts to distinguish between a target time period and a comparison time period, finding any unique differences between the two.">
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                            </ScoopText>
                        </ScoopGrid>
                        <ScoopGrid item xs={1}>
                            {selectedTab === insightTabs[0].key && (
                                <ScoopTooltip title={'Open in Data Science Discovery Studio'}>
                                    <ScoopButton variant="icon" onClick={handleOpenInStudio}>
                                        <ArrowSquareOutIcon size={20} />
                                    </ScoopButton>
                                </ScoopTooltip>
                            )}
                        </ScoopGrid>
                        <ScoopGrid item xs={1.5} className={styles.metadataBox}>
                            <div>
                                <strong>Data rows:</strong>{' '}
                                {(mlResults.numInstances ?? 0).toLocaleString()}
                            </div>
                        </ScoopGrid>
                        <ScoopGrid item xs={1.5} className={styles.metadataBox}>
                            <div>
                                <strong>Time period:</strong>
                            </div>
                            <div>
                                {mlResults.groupOne.timeRange !== 'Custom' && (
                                    <>{mlResults.groupOne.timeRange}</>
                                )}
                                {mlResults.groupOne.timeRange === 'Custom' && (
                                    <>
                                        {mlResults.groupOne.start} to {mlResults.groupOne.end}
                                    </>
                                )}
                            </div>
                        </ScoopGrid>
                        <ScoopGrid item xs={2} className={styles.metadataBox}>
                            <div>
                                <strong>Comparison period:</strong>
                            </div>
                            <div>
                                {mlResults.groupTwo.timeRange !== 'Custom' && (
                                    <>{mlResults.groupTwo.timeRange}</>
                                )}
                                {mlResults.groupTwo.timeRange === 'Custom' && (
                                    <>
                                        {mlResults.groupTwo.start} to {mlResults.groupOne.end}
                                    </>
                                )}
                            </div>
                        </ScoopGrid>
                        <ScoopGrid item xs={7} rowspan={2} className={styles.metadataBox}>
                            <div>
                                <strong>Columns used:</strong>
                                &nbsp;
                                {mlResults?.columns.map((col) => col.name).join(', ')}
                                <ScoopTooltip title="From highest signifance to lowest">
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                            </div>
                            {mlResults?.filterDescription && (
                                <div>
                                    <strong>Filters:</strong>&nbsp;{mlResults?.filterDescription}
                                </div>
                            )}
                        </ScoopGrid>
                        {mlResults.graph && (
                            <ScoopGrid item xs={12} className={styles.treeSection}>
                                <VisualizeTree graph={mlResults.graph} />
                            </ScoopGrid>
                        )}
                        <ScoopGrid item xs={12} className={styles.bulletSection}>
                            <BulletResults mlResults={mlResults} />
                        </ScoopGrid>
                    </ScoopGrid>
                </div>
            )}
        </>
    )
}
